import { render, staticRenderFns } from "./EmailTemplateDetails.vue?vue&type=template&id=6a3cf3f9&"
import script from "./EmailTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports